const PayTypes = {
    PLAN: '01',
    SESSION: '02',
    OTHER: '03',
  };
  
  export default PayTypes;
  